import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

import { ref } from 'vue'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import Card from '@/views/dashboard/_components/card/card.vue'
import UsageRate from '../usage-rate/usage-rate.vue'
import { OverallRunService, MetricServerStatusData } from './overall-run.service'


export default /*#__PURE__*/_defineComponent({
  __name: 'overall-run',
  setup(__props) {

const injector = useReflectiveInjector([OverallRunService])
const overallRunService = injector.get(OverallRunService)

const isLoading = ref(false)
const moduleData = ref({} as MetricServerStatusData)

function updateData () {
  isLoading.value = true
  return overallRunService.getMetricServerStatus().then(response => {
    moduleData.value = response.data || ({} as MetricServerStatusData)
  }).finally(() => {
    isLoading.value = false
  })
}

updateData()

return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(Card, {
    title: _ctx.$t('runStatus.overallRunTitle'),
    class: "overall-run-wrap"
  }, {
    default: _withCtx(() => [
      _createVNode(UsageRate, {
        title: "CPU",
        used: moduleData.value.cpu_usage,
        all: 100,
        unit: "%"
      }, null, 8, ["used"]),
      _createVNode(UsageRate, {
        title: _ctx.$t('runStatus.disk'),
        used: (moduleData.value.used_disk_mb || 0) / 1024,
        all: (moduleData.value.total_disk_mb || 0) / 1024,
        "alarm-rate": 80,
        unit: "GB"
      }, null, 8, ["title", "used", "all"]),
      _createVNode(UsageRate, {
        title: _ctx.$t('runStatus.physicalMemory'),
        used: (moduleData.value.used_memory_mb || 0) / 1024,
        all: (moduleData.value.total_memory_mb || 0) / 1024,
        unit: "GB"
      }, null, 8, ["title", "used", "all"]),
      _createVNode(UsageRate, {
        title: _ctx.$t('runStatus.swap'),
        used: (moduleData.value.used_swap_mb || 0) / 1024,
        all: (moduleData.value.total_swap_mb || 0) / 1024,
        unit: "GB"
      }, null, 8, ["title", "used", "all"])
    ]),
    _: 1
  }, 8, ["title"])), [
    [_directive_loading, isLoading.value]
  ])
}
}

})